import { DateTimeFormatter } from '@wix/premium-react-text';
import * as React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { ServicePendingChangesInfo } from 'types';
import { Text, SectionHelper } from '@wix/design-system';

export const PendingCycleChangeNotification: React.FC<{
  servicePendingChangesInfo: ServicePendingChangesInfo;
}> = ({ servicePendingChangesInfo }) => {
  const { t } = useTranslation();
  const {
    servicePendingChanges,
    currentBillingCycle,
    nextPaymentDetails,
  } = servicePendingChangesInfo;
  const pendingBillingCycle = servicePendingChanges!.billingCycle!.billingCycle;
  const pendingCycleTranslation = t(
    `subscription_page.pending_cycle_change.cycles.${pendingBillingCycle}.name`,
  );
  const currentCycleTranslation = t(
    `subscription_page.pending_cycle_change.cycles.${currentBillingCycle}.name`,
  );
  return (
    <SectionHelper dataHook='pending-cycle-change-notification' fullWidth>
      <Text
        weight='normal'
        size='small'
        dataHook='pending-cycle-change-notification-text'
      >
        <DateTimeFormatter
          dateFormat='shortMonth'
          render={(formatter) => (
            <Text size='small'>
              <Trans
                i18nKey='subscription_page.pending_cycle_change.notification'
                values={{
                  nextRenewalDate: formatter(
                    new Date(nextPaymentDetails!.date!).getTime(),
                  ),
                  currentCycle: currentCycleTranslation,
                  pendingCycle: pendingCycleTranslation,
                }}
                components={{
                  bold: <Text size='small' weight='bold' />,
                }}
              />
            </Text>
          )}
        />
      </Text>
    </SectionHelper>
  );
};
